"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassifierAdminPageRoutes = void 0;
const react_1 = __importDefault(require("react"));
function getClassifierAdminPageRoutes(classifierAdminPages) {
    const routes = [];
    classifierAdminPages.forEach((page) => {
        const Component = page.component;
        routes.push({
            path: 'configurations/' + page.path,
            element: react_1.default.createElement(Component, null),
            children: [
                {
                    path: '*',
                    element: react_1.default.createElement(Component, null),
                },
            ],
        });
    });
    return routes;
}
exports.getClassifierAdminPageRoutes = getClassifierAdminPageRoutes;
